import React from "react";
import HelpButton from "../HelpContent/HelpButton";
import { FloatingLabel, Form, InputGroup } from "react-bootstrap";
import MyIcon from "../Common/MyIcon";
import SmsIcon from "../../assets/icons/messages-01.svg2";
import BroadcastIcon from "../../assets/icons/library_broadcast.svg2";
import InboundIcon from "../../assets/icons/icon_inbound-01.svg2";
import OnewayIcon from "../../assets/icons/icon_1_way-01.svg2";
import TwowayOpenIcon from "../../assets/icons/icon_2_way-01.svg2";
import DynamicHeaderInput from "../Builder/nodes/Logic/Inputs/DynamicHeaderInput";
import MyCollapse from "../Common/MyCollapse";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import NewFeature from "../Builder/Components/NewFeature";

export default function SmsSendSettings({
  communicationDefaults,
  setCommunicationDefaults,
  errors,
  disabled,
}) {
  return (
    <div className="pt-2">
      <h5 className=" d-flex align-items-center">
          <MyIcon Icon={SmsIcon} width={35} className="me-2" />
          <span className="ms-2">
            <span className="fw-bold me-2">SMS Send Settings </span>
            <HelpButton helpKey="settings-SMS-send-settings" />

            <div className="small text-secondary">
              These settings control options related to outbound sms sending.
            </div>
          </span>
        </h5>

      <hr className="my-3 text-secondary" />
      {/* <FloatingLabel label="SMS From Header:" className="mb-2"> */}
      <div className="row col-6">
        <DynamicHeaderInput
          placeholder="SMS From Header:"
          onChange={(v) => {
            setCommunicationDefaults((p) => ({ ...p, SmsHeader: v }));
          }}
          value={communicationDefaults.SmsHeader}
          isDisabled={disabled}
        />
        {errors.includes("sms header not allowed") && (
          <div className="alert alert-danger p-1">SMS header not allowed</div>
        )}
      </div>
      {/* </FloatingLabel> */}
      {/* <FloatingLabel label="Validity period:" className="mb-2"> 
              <Form.Control
                placeholder="Validity period(Intelligent 2-way):"
                name="validityPeriod"
                onChange={handleCommunicationDefaults}
                value={communicationDefaults.validityPeriod}
              />
              <div className="me-2 position-absolute top-50 end-0 translate-middle-y">
                <HelpButton />
              </div>
            </FloatingLabel> */}
      <hr className="my-3 text-secondary" />
      <div className="pt-2">
        <div className="d-flex align-items-center">
          <MyIcon Icon={BroadcastIcon} width={20} />
          <span className="fw-bold ms-2"> Broadcast Settings</span>
        </div>
        <hr className="my-3 text-secondary" />
        <div className="ms-2">
          <Form.Check
            id="dynamic-header-checkbox"
            type="radio"
            label={
              <>
                <OnewayIcon width={15} className="m-1" />
                1-Way broadcast <HelpButton helpKey="1-Way-broadcast" />
              </>
            }
            className=" mt-3"
            checked={
              communicationDefaults.BroadcastSetting === "dynamic-header"
            }
            onChange={() =>
              setCommunicationDefaults((p) => ({
                ...p,
                BroadcastSetting: "dynamic-header",
              }))
            }
          />
          <Form.Check
            id="single-ticket-checkbox"
            type="radio"
            label={
              <>
                Intelligent 2-Way broadcast-Single Ticket{" "}
                <HelpButton helpKey="Intelligent-2-Way-broadcast-Single-Ticket" />
              </>
            }
            className="mt-3"
            checked={communicationDefaults.BroadcastSetting === "single-ticket"}
            onChange={() =>
              setCommunicationDefaults((p) => ({
                ...p,
                BroadcastSetting: "single-ticket",
              }))
            }
          />

          <Form.Check
            id="open-ticket-checkbox"
            type="radio"
            label={
              <>
                <TwowayOpenIcon width={15} className="m-1" />
                Intelligent 2-Way broadcast-Open Ticket{" "}
                <HelpButton helpKey="Intelligent-2-Way-broadcast-Open-Ticket" />
              </>
            }
            className=" mt-3"
            checked={communicationDefaults.BroadcastSetting === "open-ticket"}
            onChange={() =>
              setCommunicationDefaults((p) => ({
                ...p,
                BroadcastSetting: "open-ticket",
              }))
            }
          />

          <Form.Check
            id="fixed-originator-checkbox"
            type="checkbox"
            label="Do not ask user to confirm override of default originator"
            className="p-0 mt-3"
            checked={!communicationDefaults.IsBroadcastFixed}
            onChange={(e) =>
              setCommunicationDefaults((p) => ({
                ...p,
                IsBroadcastFixed: !e.target.checked,
              }))
            }
          />
          <p className="text-secondary text-small">
            Selecting this option will switch off the pop-up message in the
            broadcast builder, asking the user to confirm they are overriding
            the system default originator.
          </p>
        </div>
      </div>
      <NewFeature>
        <hr className="my-3 text-secondary" />
        <div className="row">
          <div className="col-6">
            <div className="mb-2">
              <InputGroup>
                <InputGroup.Text>Max characters</InputGroup.Text>
                <Form.Control
                  type="number"
                  aria-label="With textarea"
                  value={communicationDefaults.maxCharacters || 1244}
                  onChange={(e) =>
                    setCommunicationDefaults((p) => ({
                      ...p,
                      maxCharacters: e.target.value,
                    }))
                  }
                />
              </InputGroup>
            </div>

            <div className="bg-white p-3 rounded-3 mb-2">
              <div className="mb-2 ">Reply forward Options: </div>
              <div>
                <Input
                  isMulti
                  inputType="select"
                  value={communicationDefaults.ReplyOptions || []}
                  onChange={(v) =>
                    setCommunicationDefaults((p) => ({
                      ...p,
                      ReplyOptions: v,
                    }))
                  }
                  options={[
                    { value: "boommail", label: "Boommail" },
                    { value: "sms", label: "SMS" },
                    { value: "Email", label: "Email" },
                    { value: "api", label: "API" },
                  ]}
                  isDisabled={disabled}
                />
              </div>
            </div>
          </div>
          <div className="col-6">
            <InputGroup>
              <FloatingLabel className=" mb-2">
                Unicode on/off/replace-remove
              </FloatingLabel>

              <Form.Check // prettier-ignore
                type="switch"
                id="unicode-switch"
                name="unicode"
                checked={communicationDefaults.unicode}
                onChange={() =>
                  setCommunicationDefaults((p) => ({
                    ...p,
                    unicode: !p.unicode,
                  }))
                }
              />
            </InputGroup>

            <InputGroup>
              <FloatingLabel className=" mb-2">Spell check</FloatingLabel>

              <Form.Check // prettier-ignore
                type="switch"
                id="spellCheck-switch"
                name="spellCheck"
                checked={communicationDefaults.SpellCheck}
                onChange={() =>
                  setCommunicationDefaults((p) => ({
                    ...p,
                    spellCheck: !p.spellCheck,
                  }))
                }
              />
            </InputGroup>
            <InputGroup>
              <FloatingLabel className=" mb-2">Short-links</FloatingLabel>

              <Form.Check // prettier-ignore
                type="switch"
                id="shortLinks-switch"
                name="shortLinks"
                checked={communicationDefaults.shortLinks}
                onChange={() =>
                  setCommunicationDefaults((p) => ({
                    ...p,
                    shortLinks: !p.shortLinks,
                  }))
                }
              />
            </InputGroup>
            <InputGroup>
              <FloatingLabel className=" mb-2"> Ai prompting</FloatingLabel>

              <Form.Check // prettier-ignore
                type="switch"
                id="aiPrompting-switch"
                name="aiPrompting"
                checked={communicationDefaults.aiPrompting}
                onChange={() =>
                  setCommunicationDefaults((p) => ({
                    ...p,
                    aiPrompting: !p.aiPrompting,
                  }))
                }
              />
            </InputGroup>
          </div>
        </div>
      </NewFeature>
      <hr className="my-3 text-secondary" />
    </div>
  );
}
